<template>
  <a-form-item :label="data.fieldkey === 'from_info' ? (data.fromname) || infoFromTit : data.fieldname">
    <div
      v-decorator="[`${data.fieldkey}`, {
        validateTrigger: ['change'],
        rules: [{
          required: data.isneeded === 1 ? true : false,
          message: ' '
        }, {
          validator: checkValue
        }],
        initialValue: defaultVal
      }]"
      class="wrap"
    >
      <a-select
        v-if="data && data.options"
        v-model="defaultVal"
        :placeholder="placeholder"
        allow-clear
        :show-search="true"
        :mode="data.multiple"
        :disabled="data.disabled"
        :filter-option="filterOption"
        :get-popup-container="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        "
        @change="handleSelectChange"
        @dropdownVisibleChange="dropdownVisibleChange"
      >
        <a-select-option
          v-for="item in options"
          :key="item.id"
          :value="item.id"
          :disabled="item.disabled"
        >
          {{ item.name || item.fieldname }}
        </a-select-option>
      </a-select>
      <slot />
      <a-tooltip
        v-if="isexplain || (data.fieldkey === 'info_type' && data.isexplain)"
        placement="right"
        overlay-class-name="radio-tooltip"
      >
        <template slot="title">
          <template v-for="(item, i) in explain">
            <p
              v-if="item.name"
              :key="i"
            >
              {{ item.key }}: {{ item.name }}
            </p>
          </template>
        </template>
        <i
          v-if="(isexplain || data.fieldkey === 'info_type') && explain.length"
          class="iconfont iconicon-test34 fs-gray explain-btn"
        />
      </a-tooltip>
    </div>
  </a-form-item>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Array],
      default: ''
    }
  },
  inject: ['myForm'],
  data () {
    // let defaultVal = this.value || this.data.fieldvalue
    return {
      defaultVal: undefined
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['memberInfo']),
    explain () {
      let newExplain = []
      const { fieldconfig = {}, fieldkey, options = [] } = this.data || {}
      if (fieldkey === 'info_level') {
        const { explain = [], type } = fieldconfig
        let arr = []
        if (type === 1) {
          arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
        } else if (type === 2) {
          arr = this.$t('message["1444"]').split(',')
        }
        explain.forEach((item, index) => {
          let obj = {}
          arr.forEach((code, i) => {
            if (index === i) {
              obj.key = code
              obj.name = item
              newExplain.push(obj)
            }
          })
        })
      } else if (fieldkey === 'info_type') {
        options.forEach((item, index) => {
          if (item.typeshow) {
            newExplain.push({
              key: item.name,
              name: item.typeshow
            })
          }
        })
      }
      return newExplain || []
    },
    isexplain () {
      const { fieldconfig = {} } = this.data || {}
      let { isexplain, explain = [] } = fieldconfig
      let newExplain = explain.filter(o => o !== '')
      isexplain = isexplain && newExplain.length
      return isexplain
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    options () {
      const { options = [], fieldtype = '', parentid } = this.data || {}

      let isRadio = fieldtype === 'radio' || fieldtype === 'radioinfo_type'
      let isSelect = fieldtype === 'select'
      // 父级不是成交，丢单，失效
      let isChildModule = parentid === 5092 || parentid === 136528 || parentid === 136525
      // 信息类型和父级不是成交，丢单，失效，模块内的单选和下拉
      if ((isRadio || isSelect) && !isChildModule) {
        // 录入或审核
        if (this.$route.name === 'InqueryCreate' || this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail' || this.auditStatus === 0 || this.auditStatus === -1) {
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 2) {
              options.splice(i, 1)
            }
          }
        } else if (this.auditStatus === 1) { // 通过审核的详情
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 1) {
              options.splice(i, 1)
            }
          }
        }
      }
      return options
    },

    infoFromTit () {
      return this.$t('message["1370"]')
    }
  },
  watch: {
    value (val) {
      this.defaultVal = this.value || undefined
      this.setInvisibleValue()
    },
    data: {
      handler (val) {
        if (this.value) {
          this.defaultVal = this.value || undefined
        } else {
          this.defaultVal = val.fieldvalue || undefined
        }
        this.setInvisibleValue()
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    setInvisibleValue () {
      if (!this.defaultVal) return

      let isfind = this.options.find(item => item.id === this.defaultVal || item.fieldkey === this.defaultVal)
      if (this.defaultVal && !isfind) {
        this.defaultVal = undefined
        if (this.data.isneeded) {
          this.$emit('change', this.defaultVal)
        }
      }
    },
    handleSelectChange (value) {
      this.data.fieldvalue = value
      const { fieldkey } = this.data
      this.myForm.setFieldsValue({
        [fieldkey]: value
      })
      this.$emit('change', value)
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    dropdownVisibleChange (open) {
      this.$emit('dropdownVisibleChange', open)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    validatedCallback (err, values) {
      if (!err) {
        // this.$emit('change', this.data.fieldvalue)
      }
    },
    checkValue (rule, value, callback) {
      const { isneeded, options } = this.data || {}
      if (!isneeded) {
        callback()
      } else {
        let filter = options.filter(item => item.id === value)
        if (filter.length) {
          callback()
        } else {
          callback(new Error(`${this.$t('message["855"]')} ${this.data.fieldname}`))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.explain-btn {
  margin-left: 12px;
  vertical-align: middle;
  cursor: pointer;
}
</style>
<style lang="scss">
.radio-tooltip {
  min-width: 200px;
  max-width: 400px;
  .ant-tooltip-inner {
    color: $gray3;
    min-width: 200px;
    max-width: 400px;
  }
  .ant-tooltip-content:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 1px;
    top: 50%;
    margin-top: -7px;
    border-width: 7px 8px 7px 0;
    border-color: transparent;
    border-right-color: #ebebeb;
    border-style: solid;
  }
  &.ant-tooltip-placement-right {
    .ant-tooltip-arrow {
      left: 4px !important;
      z-index: 2;
      border-right-color: #fff !important;
    }
  }
  &.ant-tooltip-placement-left {
    .ant-tooltip-content:after {
      right: 1px;
      left: auto;
      margin-top: -7px;
      border-width: 7px 0 7px 8px;
      border-left-color: #ebebeb;
    }
    .ant-tooltip-arrow {
      right: 4px !important;
      z-index: 2;
      border-left-color: #fff !important;
    }
  }
}
</style>
